import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import * as authTypes from "./constants/authTypes";
import { getRouterBasename } from "./utils/routerBasename";

interface AnonymousAuthWrapperProps {
  children: JSX.Element;
}

const AnonymousAuthWrapper = ({ children }: AnonymousAuthWrapperProps) => {
  const basename = getRouterBasename();

  return (
    <BrowserRouter basename={basename}>
      <AuthProvider authType={authTypes.ANONYMOUS}>
        <Routes>
          <Route path="/" element={children} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AnonymousAuthWrapper;
